"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryBody = exports.Body = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _mixins = require("../../../mixins");
var _mixins2 = require("../mixins");
var _hooks = require("../../../hooks");
var _constants = require("../constants");
var _colors = require("../../../core/colors");
var _useDataAttributes = require("../../../hooks/use-data-attributes");
var _excluded = ["children", "medium", "metadata", "strikethrough", "status"],
  _excluded2 = ["children", "medium", "metadata", "strikethrough", "status"];
var StyledP = _styledComponents["default"].p.withConfig({
  displayName: "body__StyledP"
})(["", " ", " ", " font-weight:", ";font-size:1rem;line-height:1.5rem;", " ", ""], _mixins.mixins.spacingReset, _mixins2.mixins.inlineIcon, _mixins2.mixins.font, _constants.FONT_WEIGHTS.normal, function (_ref) {
  var $medium = _ref.$medium;
  return $medium && 'font-weight: bold;';
}, function (_ref2) {
  var $strikethrough = _ref2.$strikethrough;
  return $strikethrough && 'text-decoration: line-through;';
});
var Body = exports.Body = function Body(_ref3) {
  var children = _ref3.children,
    _ref3$medium = _ref3.medium,
    medium = _ref3$medium === void 0 ? false : _ref3$medium,
    _ref3$metadata = _ref3.metadata,
    metadata = _ref3$metadata === void 0 ? false : _ref3$metadata,
    _ref3$strikethrough = _ref3.strikethrough,
    strikethrough = _ref3$strikethrough === void 0 ? false : _ref3$strikethrough,
    _ref3$status = _ref3.status,
    status = _ref3$status === void 0 ? 'default' : _ref3$status,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var dataAttributes = (0, _useDataAttributes.useDataAttributes)(rest);
  var _useBonsai = (0, _hooks.useBonsai)(),
    secondaryFont = _useBonsai.secondaryFont;
  var color = status === 'active' ? _colors.COLORS.mediumBlue : metadata ? _colors.COLORS.metadata : _colors.COLORS.primaryTypography;
  return /*#__PURE__*/_react["default"].createElement(StyledP, (0, _extends2["default"])({
    $color: color,
    $font: secondaryFont,
    $medium: medium,
    $metadata: metadata,
    $status: status,
    $strikethrough: strikethrough
  }, dataAttributes), children);
};
var SecondaryStyledP = (0, _styledComponents["default"])(StyledP).withConfig({
  displayName: "body__SecondaryStyledP"
})(["font-size:0.875rem;line-height:1.25rem;"]);
var SecondaryBody = exports.SecondaryBody = function SecondaryBody(_ref4) {
  var children = _ref4.children,
    _ref4$medium = _ref4.medium,
    medium = _ref4$medium === void 0 ? false : _ref4$medium,
    _ref4$metadata = _ref4.metadata,
    metadata = _ref4$metadata === void 0 ? false : _ref4$metadata,
    _ref4$strikethrough = _ref4.strikethrough,
    strikethrough = _ref4$strikethrough === void 0 ? false : _ref4$strikethrough,
    _ref4$status = _ref4.status,
    status = _ref4$status === void 0 ? 'default' : _ref4$status,
    rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded2);
  var dataAttributes = (0, _useDataAttributes.useDataAttributes)(rest);
  var _useBonsai2 = (0, _hooks.useBonsai)(),
    secondaryFont = _useBonsai2.secondaryFont;
  return /*#__PURE__*/_react["default"].createElement(SecondaryStyledP, (0, _extends2["default"])({
    $color: _colors.COLORS.primaryTypography,
    $font: secondaryFont,
    $medium: medium,
    $metadata: metadata,
    $status: status,
    $strikethrough: strikethrough
  }, dataAttributes), children);
};